import { SlideViewerOrganism } from '@online-webinar/player';
import { useParams } from '@online-webinar/router';
import { useEffect } from 'react';

export const SlideViewer = () => {
    const { webinarId, linkCode } = useParams({ strict: false });

    useEffect(() => {
        document.body.classList.add('no-menu');
        return () => {
            document.body.classList.remove('no-menu');
        };
    }, []);

    return <SlideViewerOrganism webinarId={webinarId!} linkCode={linkCode} />;
};
